import { Theme } from '@mui/material/styles';
import { PaymentContent } from 'core/flow/entities/Content';
import { PaymentFormParams } from 'core/payments/entities';

type GetDefaultParamsProps = {
  theme: Theme;
  content: PaymentContent;
};

export const getDefaultParams = ({ content, theme }: GetDefaultParamsProps): PaymentFormParams => ({
  formParams: {
    submitButtonText: content.buttonPayByCard,
    googleFontLink: 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap',
    isCardHolderVisible: true,
  },
  styles: {
    submit_button: {
      'font-size': '14px',
      background: theme.palette.success.main,
      'border-radius': '30px',
      height: '49px',
      ':disabled': {
        'background-color': theme.palette.button.mainDisabled,
      },
    },
    input_group: {
      '.input-block': {
        flex: 'none',
      },
      input: {
        border: `1px solid ${theme.palette.input.main}`,
        'background-color': theme.palette.common.white,
      },
      label: {
        color: `${theme.palette.text.main}!important`,
      },
    },
  },
});
